var map = {
	"./chart-on.svg": 256,
	"./gear-on.svg": 6033,
	"./magnifier-on.svg": 487,
	"./mainStar-on.svg": 5629,
	"./sims-on.svg": 9716,
	"./stars-on.svg": 758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2979;